"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFormSchemaRefined = void 0;
/**
 * Method to strip out any unknown properties and return a @type {FormSchemaProperties}.
 * @param formSchema - An object with @type {FormSchemaProperties} and potentially more unwanted properties.
 * @returns - A clean @type {FormSchemaProperties}.
 */
const buildFormSchemaRefined = (formSchema) => ({
    EMPLOYMENT: formSchema['EMPLOYMENT'],
    PROFESSIONAL: formSchema['PROFESSIONAL'],
    SUBJECT: formSchema['SUBJECT'],
    TERTIARY: formSchema['TERTIARY'],
});
exports.buildFormSchemaRefined = buildFormSchemaRefined;
//# sourceMappingURL=FormSchemaRefined.js.map